import React from "react";

const GlobalLoadingComponent = ({ text = "Loading..." }) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-apple-blue-50/95 via-purple-50/95 to-pink-50/95 backdrop-blur-xl z-50 flex flex-col items-center justify-center transition-all duration-500">
      <div className="glass-card flex flex-col items-center p-12 rounded-3xl animate-scale-in">
        {/* Loading spinner */}
        <div className="relative">
          {/* Outer ring - slowly rotating */}
          <div className="w-28 h-28 border-4 border-apple-gray-200 rounded-full animate-spin-slow"></div>
          {/* Inner spinner - faster rotation */}
          <div className="absolute top-0 left-0 w-28 h-28 border-t-4 border-apple-blue-600 rounded-full animate-spin"></div>
          {/* Center dot */}
          <div className="absolute top-1/2 left-1/2 w-4 h-4 bg-apple-blue-600 rounded-full transform -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        </div>

        {/* Text message */}
        <div className="mt-10 text-center">
          <p className="text-apple-gray-900 font-bold text-xl tracking-wide text-display">
            {text}
          </p>
          <div className="mt-4 flex justify-center space-x-1">
            <div className="w-2 h-2 bg-apple-blue-600 rounded-full animate-bounce" style={{animationDelay: '0ms'}}></div>
            <div className="w-2 h-2 bg-apple-blue-600 rounded-full animate-bounce" style={{animationDelay: '150ms'}}></div>
            <div className="w-2 h-2 bg-apple-blue-600 rounded-full animate-bounce" style={{animationDelay: '300ms'}}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Define your CSS animation keyframes with Tailwind classes
// This is added as a custom style that needs to be included in your CSS
const GlobalStyles = () => (
  <style>{`
    @keyframes spin-slow {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .animate-spin-slow {
      animation: spin-slow 3s linear infinite;
    }
  `}</style>
);

// Export a wrapped component that includes both the loading UI and the styles
const GlobalLoading = ({ text = "Loading..." }: any) => (
  <>
    <GlobalStyles />
    <GlobalLoadingComponent text={text} />
  </>
);

export default GlobalLoading;
